import React from 'react';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export type IconProps = {
  leftMargin?: boolean,
  rightMargin?: boolean,
  isLoading?: boolean,
} & FontAwesomeIconProps;

const StyledFontAwesomeIcon: React.FC<IconProps> = ({
  leftMargin = false, rightMargin = true, onClick, ...rest
}) => {
  // We don't use styled components in this case as there was some warning
  // with FontAwesomeIcon not knowing the margin props and the code would be more
  // complicated than this code here.
  const style: React.CSSProperties = {
    marginLeft: leftMargin ? '7px' : '0px',
    marginRight: rightMargin ? '7px' : '0px',
  };
  if (onClick) {
    style.cursor = 'pointer';
  }
  return (
    <FontAwesomeIcon style={style} onClick={onClick} {...rest} />
  );
};

export const Icon: React.FC<IconProps> = ({ isLoading, ...rest }) => (
  isLoading ? <StyledFontAwesomeIcon {...rest} icon={faSpinner} pulse /> : <StyledFontAwesomeIcon {...rest} />
);
